/**

 * Town Tools Navigation — Mega menu dropdown (desktop) + off-canvas drawer (mobile)

 *

 * Desktop behaviour:

 *   - Hover L1 in header bar → opens mega menu dropdown below header

 *   - Mega menu shows all L2 headings with L3 children in columns + promo sidebar

 *   - Sticky mode: hamburger click → L1 strip in header → hover/click opens mega menu

 *   - ESC / overlay click / mouse leave → close

 *

 * Mobile behaviour (unchanged):

 *   - Hamburger → full-screen L1 list

 *   - Tap L1 → slide to L2 screen

 *   - Tap L2 with children → slide to L3

 *   - Back button navigates stack

 */



(function () {

  'use strict';



  /* ============================================================

     SELECTORS

     ============================================================ */

  var SEL = {

    drawer:       '[data-tt-drawer]',

    overlay:      '[data-tt-drawer-overlay]',

    toggleBtn:    '[data-tt-drawer-toggle]',

    closeBtn:     '[data-tt-drawer-close]',

    backBtn:      '[data-tt-drawer-back]',

    title:        '[data-tt-drawer-title]',

    panel:        '[data-tt-panel]',

    l1Trigger:    '[data-tt-l1-trigger]',

    l2Trigger:    '[data-tt-l2-trigger]',

    l2HoverLink:  '[data-tt-l2-hover]',

    promoGlobal:  '[data-tt-promo-global]',

    headerNavLink:'.tt-header__nav-link',

    searchToggle: '[data-tt-search-toggle]',

    searchOverlay:'[data-tt-search-overlay]',

    searchInput:  '[data-tt-search-input]',

    searchClose:  '[data-tt-search-close]',

    megamenu:     '[data-tt-megamenu]',

    megamenuPanel:'[data-megamenu-panel]',

    megamenuClose:'[data-megamenu-close]',

    stickyL1Strip:'[data-tt-sticky-l1-strip]',

    stickyL1Link: '[data-sticky-l1]',

  };



  /* ============================================================

     STATE

     ============================================================ */

  var state = {

    isOpen: false,

    isDrilled: false,

    navStack: [],

    activeL1Handle: null,

    activeL2Handle: null,

    activeL1Title: null,

    isDesktop: false,

    // Mega menu state

    megamenuOpen: false,

    megamenuActiveL1: null,

    stickyL1StripOpen: false,

  };



  /* ============================================================

     DOM REFS

     ============================================================ */

  var refs = {};



  // Brief guard timestamp: prevents scroll handler from leaving sticky state

  // immediately after L1 strip or mega menu opens (layout change can trigger reflow)

  var stickyGuardUntil = 0;



  /* ============================================================

     UTILITIES

     ============================================================ */

  function isDesktop() {

    return window.matchMedia('(min-width: 768px)').matches;

  }



  function getFocusableElements(container) {

    return Array.from(container.querySelectorAll(

      'a[href]:not([hidden]), button:not([disabled]):not([hidden]):not([aria-hidden="true"]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'

    )).filter(function(el) { return el.offsetParent !== null; });

  }



  /* ============================================================

     STICKY HEADER — Mobile: 3-state scroll behavior

     ============================================================ */

  function setupStickyHeader() {

    var headerEl = document.querySelector('.tt-header');

    if (!headerEl) return;



    var placeholder = document.createElement('div');

    placeholder.className = 'tt-header-placeholder';

    headerEl.parentNode.insertBefore(placeholder, headerEl.nextSibling);



    var headerHeight = 0;

    var lastScrollY = 0;

    var ticking = false;

    var currentState = 'top';

    var scrollAccumulator = 0;

    var lastDirectionY = 0;

    var TOP_THRESHOLD = 10;

    var SCROLL_UP_THRESHOLD = 40;

    var SCROLL_DOWN_THRESHOLD = 20;

    var MIN_DELTA = 2;



    function isMobile() {

      return window.matchMedia('(max-width: 767px)').matches;

    }



    function measure() {

      var hadSticky = headerEl.classList.contains('is-sticky');

      var hadHidden = headerEl.classList.contains('is-hidden');

      headerEl.classList.remove('is-sticky', 'is-hidden');

      placeholder.style.display = 'none';

      headerHeight = headerEl.offsetHeight;

      placeholder.style.height = headerHeight + 'px';

      if (hadSticky) headerEl.classList.add('is-sticky');

      if (hadHidden) headerEl.classList.add('is-hidden');

      if (hadSticky) placeholder.style.display = 'block';

    }



    function setState(newState) {

      if (newState === currentState) return;



      // Brief guard: don't leave sticky state right after L1 strip or mega menu

      // opens — the layout change can trigger a scroll reflow that would

      // immediately close what just opened. Guard expires after 500ms.

      if (currentState === 'sticky' && newState !== 'sticky' &&

          Date.now() < stickyGuardUntil) {

        return;

      }



      var oldState = currentState;

      currentState = newState;



      if (newState === 'top') {

        headerEl.classList.remove('is-sticky', 'is-hidden', 'no-transition');

        placeholder.style.display = 'none';

        // Close sticky L1 strip if open (safety net — guarded above)

        if (state.stickyL1StripOpen) closeStickyL1Strip();

      } else if (newState === 'hidden') {

        if (oldState === 'top') {

          headerEl.classList.add('no-transition');

          headerEl.classList.add('is-sticky', 'is-hidden');

          placeholder.style.display = 'block';

          headerEl.offsetHeight;

          headerEl.classList.remove('no-transition');

        } else {

          headerEl.classList.add('is-sticky', 'is-hidden');

          placeholder.style.display = 'block';

        }

      } else if (newState === 'sticky') {

        headerEl.classList.remove('no-transition');

        headerEl.classList.add('is-sticky');

        headerEl.classList.remove('is-hidden');

        placeholder.style.display = 'block';

      }



      scrollAccumulator = 0;

      lastDirectionY = lastScrollY;

    }



    function updateHeader() {

      var currentScrollY = Math.max(0, window.pageYOffset);

      var delta = currentScrollY - lastScrollY;



      if (Math.abs(delta) < MIN_DELTA) {

        ticking = false;

        return;

      }



      if (currentScrollY <= TOP_THRESHOLD) {

        setState('top');

        lastScrollY = currentScrollY;

        ticking = false;

        return;

      }



      if (isMobile()) {

        if (delta > 0) {

          if (scrollAccumulator < 0) {

            scrollAccumulator = delta;

            lastDirectionY = lastScrollY;

          } else {

            scrollAccumulator += delta;

          }

          if (scrollAccumulator >= SCROLL_DOWN_THRESHOLD && currentState !== 'hidden') {

            setState('hidden');

          }

        } else {

          if (scrollAccumulator > 0) {

            scrollAccumulator = delta;

            lastDirectionY = lastScrollY;

          } else {

            scrollAccumulator += delta;

          }

          if (scrollAccumulator <= -SCROLL_UP_THRESHOLD && currentState !== 'sticky') {

            setState('sticky');

          }

        }

      } else {

        if (currentState !== 'sticky') {

          setState('sticky');

        }

      }



      lastScrollY = currentScrollY;

      ticking = false;

    }



    function onScroll() {

      if (!ticking) {

        ticking = true;

        requestAnimationFrame(updateHeader);

      }

    }



    measure();

    lastScrollY = window.pageYOffset;



    if (lastScrollY <= TOP_THRESHOLD) {

      setState('top');

    } else if (isMobile()) {

      setState('hidden');

    } else {

      setState('sticky');

    }



    window.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener('resize', function() {

      requestAnimationFrame(measure);

    });

  }



  /* ============================================================

     DRAWER POSITION — keeps drawer below header

     ============================================================ */

  function updateDrawerPosition() {

    var headerEl = document.querySelector('.tt-header');

    if (!headerEl) return;

    var rect = headerEl.getBoundingClientRect();

    var topVal = Math.max(0, rect.bottom);

    document.documentElement.style.setProperty('--tt-drawer-top', topVal + 'px');

  }



  /* ============================================================

     MEGA MENU — Desktop dropdown

     ============================================================ */

  function openMegamenu(l1Handle) {

    if (!isDesktop()) return;



    // Close drawer if open

    if (state.isOpen) closeDrawer();



    // Close search if open

    var searchOverlay = document.querySelector(SEL.searchOverlay);

    if (searchOverlay && !searchOverlay.hidden) {

      closeSearch();

    }



    // Position mega menu

    updateMegamenuPosition();



    // Prevent scroll-triggered state changes from closing mega menu

    stickyGuardUntil = Date.now() + 500;



    // Hide all panels, show the target

    if (refs.megamenuPanels) {

      refs.megamenuPanels.forEach(function(p) {

        p.classList.remove('is-active');

        p.hidden = true;

      });

    }



    var panel = document.querySelector('[data-megamenu-panel="' + l1Handle + '"]');

    if (panel) {

      panel.classList.add('is-active');

      panel.hidden = false;

    }



    if (refs.megamenu) {

      refs.megamenu.hidden = false;

      void refs.megamenu.offsetHeight;

      refs.megamenu.classList.add('is-open');

    }



    // Show overlay

    refs.overlay.classList.add('is-visible');



    // Add drawer-active class for full-bar mode

    var headerEl = document.querySelector('.tt-header');

    if (headerEl) headerEl.classList.add('tt-drawer-active');



    state.megamenuOpen = true;

    state.megamenuActiveL1 = l1Handle;



    highlightHeaderNavLink(l1Handle);

    highlightStickyL1Link(l1Handle);



    document.body.classList.add('tt-drawer-open');

    document.addEventListener('keydown', handleKeyDown);

    window.addEventListener('scroll', updateMegamenuPosition, { passive: true });

  }



  function closeMegamenu() {

    if (!state.megamenuOpen) return;



    if (refs.megamenu) {

      refs.megamenu.classList.remove('is-open');

    }

    refs.overlay.classList.remove('is-visible');



    state.megamenuOpen = false;

    state.megamenuActiveL1 = null;



    clearHeaderNavHighlights();

    clearStickyL1Highlights();

    document.body.classList.remove('tt-drawer-open');

    document.removeEventListener('keydown', handleKeyDown);

    window.removeEventListener('scroll', updateMegamenuPosition);



    // Remove drawer-active if L1 strip is not open

    var headerEl = document.querySelector('.tt-header');

    if (headerEl && !state.stickyL1StripOpen) {

      headerEl.classList.remove('tt-drawer-active');

    }



    // After transition, hide

    setTimeout(function() {

      if (!state.megamenuOpen && refs.megamenu) {

        refs.megamenu.hidden = true;

        if (refs.megamenuPanels) {

          refs.megamenuPanels.forEach(function(p) {

            p.classList.remove('is-active');

            p.hidden = true;

          });

        }

      }

    }, 300);

  }



  function updateMegamenuPosition() {

    var headerEl = document.querySelector('.tt-header');

    if (!headerEl || !refs.megamenu) return;

    var rect = headerEl.getBoundingClientRect();

    refs.megamenu.style.top = rect.bottom + 'px';

    // Also update drawer overlay top

    document.documentElement.style.setProperty('--tt-drawer-top', rect.bottom + 'px');

  }



  /* ============================================================

     STICKY L1 STRIP — Horizontal L1 links in sticky header

     ============================================================ */

  function openStickyL1Strip() {

    var strip = refs.stickyL1Strip;

    if (!strip) return;



    // Close any open mega menu

    if (state.megamenuOpen) closeMegamenu();

    if (state.isOpen) closeDrawer();



    strip.hidden = false;

    strip.classList.add('is-visible');

    state.stickyL1StripOpen = true;

    stickyGuardUntil = Date.now() + 500;



    var headerEl = document.querySelector('.tt-header');

    if (headerEl) {

      headerEl.classList.add('tt-drawer-active');

      headerEl.classList.add('tt-sticky-l1-active');

    }



    refs.toggleBtn.forEach(function(btn) { btn.setAttribute('aria-expanded', 'true'); });

  }



  function closeStickyL1Strip() {

    var strip = refs.stickyL1Strip;

    if (!strip) return;



    strip.classList.remove('is-visible');

    strip.hidden = true;

    state.stickyL1StripOpen = false;



    var headerEl = document.querySelector('.tt-header');

    if (headerEl) {

      headerEl.classList.remove('tt-sticky-l1-active');

      if (!state.isOpen && !state.megamenuOpen) {

        headerEl.classList.remove('tt-drawer-active');

      }

    }



    refs.toggleBtn.forEach(function(btn) { btn.setAttribute('aria-expanded', 'false'); });

    clearStickyL1Highlights();

  }



  function toggleStickyL1Strip() {

    if (state.stickyL1StripOpen) {

      closeStickyL1Strip();

    } else {

      openStickyL1Strip();

    }

  }



  function highlightStickyL1Link(handle) {

    if (!refs.stickyL1Links) return;

    refs.stickyL1Links.forEach(function(link) {

      link.classList.toggle('is-active', link.dataset.stickyL1 === handle);

    });

  }



  function clearStickyL1Highlights() {

    if (!refs.stickyL1Links) return;

    refs.stickyL1Links.forEach(function(link) {

      link.classList.remove('is-active');

    });

  }



  /* ============================================================

     DRAWER OPEN / CLOSE (mobile + non-sticky desktop hamburger)

     ============================================================ */

  function openDrawer(options) {

    options = options || {};

    if (state.isOpen && !options.switchL1) return;



    // Close search if open

    var searchOverlay = document.querySelector(SEL.searchOverlay);

    if (searchOverlay && !searchOverlay.hidden) {

      closeSearch();

    }



    // Close mega menu if open

    if (state.megamenuOpen) closeMegamenu();



    state.isDesktop = isDesktop();



    if (!state.isOpen) {

      state.isOpen = true;

      state.isDrilled = false;

      state.navStack = [{ level: 'l1', title: 'Menu' }];

      state.activeL1Handle = null;



      updateDrawerPosition();



      refs.drawer.hidden = false;

      void refs.drawer.offsetHeight;

      refs.drawer.classList.add('is-open');

      refs.overlay.classList.add('is-visible');



      refs.toggleBtn.forEach(function(btn) { btn.setAttribute('aria-expanded', 'true'); });

      document.body.classList.add('tt-drawer-open');



      var headerEl = document.querySelector('.tt-header');

      if (headerEl) headerEl.classList.add('tt-drawer-active');



      document.addEventListener('keydown', handleKeyDown);

      window.addEventListener('scroll', updateDrawerPosition, { passive: true });

    }



    if (options.l1Handle) {

      if (state.isDesktop) {

        showDesktopHoverL2(options.l1Handle);

      } else {

        var title = options.l1Title || 'Menu';

        state.navStack = [{ level: 'l1', title: 'Menu' }];

        navigateToL2(options.l1Handle, title);

      }

    } else if (!options.switchL1) {

      showL1();

    }



    updateDrawerHeader();



    if (!options.switchL1) {

      requestAnimationFrame(function() {

        var closeBtn = refs.drawer.querySelector(SEL.closeBtn);

        if (closeBtn) closeBtn.focus();

      });

    }

  }



  function closeDrawer() {

    if (!state.isOpen) return;

    state.isOpen = false;

    state.isDrilled = false;

    state.activeL1Handle = null;



    refs.drawer.classList.remove('is-open');

    refs.overlay.classList.remove('is-visible');



    refs.toggleBtn.forEach(function(btn) { btn.setAttribute('aria-expanded', 'false'); });

    document.body.classList.remove('tt-drawer-open');

    window.removeEventListener('scroll', updateDrawerPosition);



    var headerEl = document.querySelector('.tt-header');

    if (headerEl && !state.stickyL1StripOpen) {

      headerEl.classList.remove('tt-drawer-active');

    }



    clearHeaderNavHighlights();



    refs.drawer.addEventListener('transitionend', function onEnd() {

      refs.drawer.removeEventListener('transitionend', onEnd);

      if (!state.isOpen) {

        refs.drawer.hidden = true;

        resetAllPanels();

      }

    }, { once: true });



    var firstToggle = refs.toggleBtn[0];

    if (firstToggle) firstToggle.focus();



    document.removeEventListener('keydown', handleKeyDown);

  }



    /* ============================================================
     L3 TEMPLATE HYDRATION
     Deferred L3 panels live inside <template> tags to reduce
     initial HTML weight. This function clones them into the real
     DOM on first access so images load only when needed.
     ============================================================ */
  function hydrateL3(key) {
    // Already hydrated — return the real panel
    var existing = refs.drawer.querySelector('div[data-l3-for="' + key + '"]');
    if (existing) return existing;

    // Find the deferred <template> and clone its content into the DOM
    var tpl = refs.drawer.querySelector('template[data-l3-for="' + key + '"]');
    if (!tpl) return null;

    var clone = tpl.content.firstElementChild.cloneNode(true);
    tpl.parentNode.insertBefore(clone, tpl);
    tpl.remove();
    return clone;
  }

/* ============================================================

     PANEL MANAGEMENT (drawer — used on mobile + desktop fallback)

     ============================================================ */

  function resetAllPanels() {

    refs.drawer.querySelectorAll(SEL.panel).forEach(function(panel) {

      panel.classList.remove('is-active', 'has-l2-active', 'has-l3-active');

      panel.hidden = true;

    });

    refs.drawer.querySelectorAll(SEL.l1Trigger).forEach(function(btn) {

      btn.setAttribute('aria-expanded', 'false');

      btn.classList.remove('is-active');

    });

    refs.drawer.querySelectorAll(SEL.l2Trigger).forEach(function(btn) {

      btn.setAttribute('aria-expanded', 'false');

      btn.classList.remove('is-active');

    });

    var globalPromo = refs.drawer.querySelector(SEL.promoGlobal);

    if (globalPromo) globalPromo.hidden = false;

    refs.drawer.querySelectorAll('.tt-drawer__promo-rail--category').forEach(function(promo) {

      promo.classList.remove('is-active');

    });

  }



  function showL1() {

    refs.drawer.querySelectorAll(SEL.panel).forEach(function(p) {

      p.classList.remove('is-active');

      p.hidden = true;

    });

    var l1Panel = refs.drawer.querySelector('[data-tt-panel="l1"]');

    if (l1Panel) {

      l1Panel.classList.add('is-active');

      l1Panel.classList.remove('has-l2-active');

      l1Panel.hidden = false;

    }

    var globalPromo = refs.drawer.querySelector(SEL.promoGlobal);

    if (globalPromo) globalPromo.hidden = false;

    refs.drawer.querySelectorAll('.tt-drawer__promo-rail--category').forEach(function(promo) {

      promo.classList.remove('is-active');

    });

    refs.drawer.querySelectorAll(SEL.l1Trigger).forEach(function(btn) {

      btn.classList.remove('is-active');

      btn.setAttribute('aria-expanded', 'false');

    });

    state.activeL1Handle = null;

    state.isDrilled = false;

  }



  function showDesktopHoverL2(handle) {

    refs.drawer.querySelectorAll('[data-tt-panel="l2"]').forEach(function(p) {

      p.classList.remove('is-active');

      p.hidden = true;

    });

    hideDesktopL3();

    var l1Panel = refs.drawer.querySelector('[data-tt-panel="l1"]');

    if (l1Panel) {

      l1Panel.classList.add('is-active');

      l1Panel.classList.add('has-l2-active');

      l1Panel.hidden = false;

    }

    var globalPromo = refs.drawer.querySelector(SEL.promoGlobal);

    if (globalPromo) globalPromo.hidden = true;

    refs.drawer.querySelectorAll('.tt-drawer__promo-rail--category').forEach(function(promo) {

      promo.classList.remove('is-active');

    });

    var categoryPromo = refs.drawer.querySelector('[data-promo-for="' + handle + '"]');

    if (categoryPromo) categoryPromo.classList.add('is-active');

    var l2Panel = refs.drawer.querySelector('[data-l2-for="' + handle + '"]');

    if (l2Panel) {

      l2Panel.classList.add('is-active');

      l2Panel.hidden = false;

    }

    refs.drawer.querySelectorAll(SEL.l1Trigger).forEach(function(btn) {

      var isActive = btn.dataset.l1Handle === handle;

      btn.classList.toggle('is-active', isActive);

      btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');

    });

    state.activeL1Handle = handle;

    state.activeL2Handle = null;

    state.isDrilled = false;

    highlightHeaderNavLink(handle);

  }



  function showDesktopHoverL3(l1Handle, l2Handle) {

    refs.drawer.querySelectorAll('[data-tt-panel="l3"]').forEach(function(p) {

      p.classList.remove('is-active');

      p.hidden = true;

    });

    var l2Panel = refs.drawer.querySelector('[data-l2-for="' + l1Handle + '"]');

    if (l2Panel) l2Panel.classList.add('has-l3-active');

    var l3Key = l1Handle + '__' + l2Handle;

    var l3Panel = hydrateL3(l3Key);

    if (l3Panel) {

      l3Panel.classList.add('is-active');

      l3Panel.hidden = false;

    }

    refs.drawer.querySelectorAll(SEL.l2Trigger).forEach(function(btn) {

      var isActive = btn.dataset.l1Handle === l1Handle && btn.dataset.l2Handle === l2Handle;

      btn.classList.toggle('is-active', isActive);

      btn.setAttribute('aria-expanded', isActive ? 'true' : 'false');

    });

    refs.drawer.querySelectorAll(SEL.l2HoverLink).forEach(function(link) {

      var isActive = link.dataset.l1Handle === l1Handle && link.dataset.l2Handle === l2Handle;

      link.classList.toggle('is-active', isActive);

    });

    state.activeL2Handle = l2Handle;

  }



  function hideDesktopL3() {

    refs.drawer.querySelectorAll('[data-tt-panel="l3"]').forEach(function(p) {

      p.classList.remove('is-active');

      p.hidden = true;

    });

    refs.drawer.querySelectorAll('[data-tt-panel="l2"]').forEach(function(p) {

      p.classList.remove('has-l3-active');

    });

    refs.drawer.querySelectorAll(SEL.l2Trigger).forEach(function(btn) {

      btn.classList.remove('is-active');

      btn.setAttribute('aria-expanded', 'false');

    });

    refs.drawer.querySelectorAll(SEL.l2HoverLink).forEach(function(link) {

      link.classList.remove('is-active');

    });

    state.activeL2Handle = null;

  }



  function showDesktopDrilledL2(handle) {

    var l1Panel = refs.drawer.querySelector('[data-tt-panel="l1"]');

    if (l1Panel) {

      l1Panel.classList.remove('is-active');

      l1Panel.hidden = true;

    }

    refs.drawer.querySelectorAll('[data-tt-panel="l2"]').forEach(function(p) {

      p.classList.remove('is-active');

      p.hidden = true;

    });

    refs.drawer.querySelectorAll('[data-tt-panel="l3"]').forEach(function(p) {

      p.classList.remove('is-active');

      p.hidden = true;

    });

    refs.drawer.querySelectorAll('.tt-drawer__promo-rail--category').forEach(function(promo) {

      promo.classList.remove('is-active');

    });

    var categoryPromo = refs.drawer.querySelector('[data-promo-for="' + handle + '"]');

    if (categoryPromo) categoryPromo.classList.add('is-active');

    var l2Panel = refs.drawer.querySelector('[data-l2-for="' + handle + '"]');

    if (l2Panel) {

      l2Panel.classList.add('is-active');

      l2Panel.hidden = false;

    }

    state.activeL1Handle = handle;

    state.isDrilled = true;

    highlightHeaderNavLink(handle);

  }



  function showMobilePanel(level, handle, parentHandle) {

    refs.drawer.querySelectorAll(SEL.panel).forEach(function(p) {

      p.classList.remove('is-active');

      p.hidden = true;

    });

    var targetPanel;

    if (level === 'l1') {

      targetPanel = refs.drawer.querySelector('[data-tt-panel="l1"]');

      var globalPromo = refs.drawer.querySelector(SEL.promoGlobal);

      if (globalPromo) globalPromo.hidden = false;

    } else if (level === 'l2') {

      targetPanel = refs.drawer.querySelector('[data-l2-for="' + handle + '"]');

    } else if (level === 'l3') {

      var compound = parentHandle + '__' + handle;

      targetPanel = hydrateL3(compound);

    }

    if (targetPanel) {

      targetPanel.classList.add('is-active');

      targetPanel.hidden = false;

    }

  }



  function updateDrawerHeader() {

    var current = state.navStack[state.navStack.length - 1];

    var backBtn = refs.drawer.querySelector(SEL.backBtn);

    var titleEl = refs.drawer.querySelector(SEL.title);



    if (state.isDesktop) {

      if (backBtn) backBtn.hidden = !state.isDrilled;

    } else {

      if (backBtn) backBtn.hidden = state.navStack.length <= 1;

    }



    if (titleEl) {

      if (current && current.level === 'l2') {

        titleEl.textContent = 'Menu';

      } else if (current && current.level === 'l3') {

        titleEl.textContent = current.l1Title || 'Menu';

      } else {

        titleEl.textContent = 'Menu';

      }

    }

  }



  /* ============================================================

     NAVIGATION (drawer)

     ============================================================ */

  function navigateToL2(handle, title) {

    state.navStack.push({ level: 'l2', handle: handle, title: title, l1Title: title });

    state.activeL1Handle = handle;

    state.activeL1Title = title;

    if (state.isDesktop) {

      showDesktopDrilledL2(handle);

    } else {

      showMobilePanel('l2', handle);

    }

    state.isDrilled = true;

    updateDrawerHeader();

    scrollDrawerTop();

  }



  function navigateToL3(parentHandle, handle, title) {

    state.navStack.push({

      level: 'l3', handle: handle, parentHandle: parentHandle,

      title: title, l1Title: state.activeL1Title

    });

    if (state.isDesktop) {

      refs.drawer.querySelectorAll(SEL.panel).forEach(function(p) {

        p.classList.remove('is-active');

        p.hidden = true;

      });

      var compound = parentHandle + '__' + handle;

      var l3Panel = hydrateL3(compound);

      if (l3Panel) {

        l3Panel.classList.add('is-active');

        l3Panel.hidden = false;

      }

    } else {

      showMobilePanel('l3', handle, parentHandle);

    }

    state.isDrilled = true;

    updateDrawerHeader();

    scrollDrawerTop();

  }



  function navigateBack() {

    if (state.navStack.length <= 1) return;

    state.navStack.pop();

    var current = state.navStack[state.navStack.length - 1];

    if (current.level === 'l1') {

      if (state.isDesktop) {

        showL1();

      } else {

        showMobilePanel('l1');

      }

      state.isDrilled = false;

      clearHeaderNavHighlights();

    } else if (current.level === 'l2') {

      if (state.isDesktop) {

        showDesktopDrilledL2(current.handle);

      } else {

        showMobilePanel('l2', current.handle);

      }

    }

    updateDrawerHeader();

    scrollDrawerTop();

  }



  function scrollDrawerTop() {

    var body = refs.drawer.querySelector('.tt-drawer__body');

    if (body) body.scrollTop = 0;

  }



  /* ============================================================

     HEADER NAV LINK HIGHLIGHTS

     ============================================================ */

  function highlightHeaderNavLink(handle) {

    document.querySelectorAll(SEL.headerNavLink).forEach(function(link) {

      link.classList.toggle('is-active', link.dataset.l1Title === handle);

    });

  }



  function clearHeaderNavHighlights() {

    document.querySelectorAll(SEL.headerNavLink).forEach(function(link) {

      link.classList.remove('is-active');

    });

  }



  /* ============================================================

     DESKTOP HOVER FROM HEADER NAV LINKS — Opens mega menu

     ============================================================ */

  var headerHoverTimer = null;

  var headerLeaveTimer = null;



  function handleHeaderNavEnter(e) {

    if (!isDesktop()) return;

    clearTimeout(headerLeaveTimer);



    var link = e.currentTarget;

    var handle = link.dataset.l1Title;

    if (!handle) return;



    // Check if this L1 has a mega menu panel

    var panel = document.querySelector('[data-megamenu-panel="' + handle + '"]');

    if (!panel) return;



    clearTimeout(headerHoverTimer);

    headerHoverTimer = setTimeout(function() {

      if (state.megamenuOpen && state.megamenuActiveL1 === handle) return;

      openMegamenu(handle);

    }, 120);

  }



  function handleHeaderNavLeave(e) {

    if (!isDesktop()) return;

    clearTimeout(headerHoverTimer);



    headerLeaveTimer = setTimeout(function() {

      // Check if mouse is over the mega menu

      if (refs.megamenu && refs.megamenu.matches(':hover')) return;

      if (state.megamenuOpen) {

        closeMegamenu();

      }

    }, 250);

  }



  /* ============================================================

     KEYBOARD HANDLING

     ============================================================ */

  function handleKeyDown(e) {

    if (e.key === 'Escape') {

      e.preventDefault();

      if (state.megamenuOpen) {

        closeMegamenu();

        return;

      }

      if (state.isOpen) {

        closeDrawer();

        return;

      }

    }



    if (e.key === 'Tab' && state.isOpen) {

      var focusable = getFocusableElements(refs.drawer);

      if (focusable.length === 0) return;

      var first = focusable[0];

      var last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {

        e.preventDefault();

        last.focus();

      } else if (!e.shiftKey && document.activeElement === last) {

        e.preventDefault();

        first.focus();

      }

    }

  }



  /* ============================================================

     SEARCH OVERLAY & PREDICTIVE SEARCH

     ============================================================ */

  var searchDebounceTimer = null;

  var currentSearchQuery = '';



  function toggleSearch() {

    var overlay = document.querySelector(SEL.searchOverlay);

    if (!overlay) return;

    if (overlay.hidden) {

      if (state.isOpen) closeDrawer();

      if (state.megamenuOpen) closeMegamenu();

      openSearch();

    } else {

      closeSearch();

    }

  }



  function openSearch() {

    var overlay = document.querySelector(SEL.searchOverlay);

    var header = document.querySelector('.tt-header');

    if (!overlay) return;

    overlay.hidden = false;

    if (header) header.classList.add('tt-search-open');

    document.querySelectorAll(SEL.searchToggle).forEach(function(btn) {

      btn.setAttribute('aria-expanded', 'true');

    });

    var input = overlay.querySelector(SEL.searchInput);

    if (input) requestAnimationFrame(function() { input.focus(); });

  }



  function closeSearch() {

    var overlay = document.querySelector(SEL.searchOverlay);

    var header = document.querySelector('.tt-header');

    if (overlay) overlay.hidden = true;

    if (header) header.classList.remove('tt-search-open');

    document.querySelectorAll(SEL.searchToggle).forEach(function(btn) {

      btn.setAttribute('aria-expanded', 'false');

    });

    hideSearchResults();

  }



  function hideSearchResults() {

    var results = document.querySelector('[data-tt-search-results]');

    if (results) results.hidden = true;

  }



  /* ============================================================

     ENHANCED STORE LOCATOR MODAL

     ============================================================ */

  function toggleLocationPopup() {

    var modal = document.querySelector('[data-tt-location-popup]');

    if (!modal) return;

    if (modal.classList.contains('is-visible')) {

      closeLocationPopup();

    } else {

      openLocationPopup();

    }

  }



  function openLocationPopup() {

    var modal = document.querySelector('[data-tt-location-popup]');

    var overlay = document.querySelector('[data-tt-location-overlay]');

    if (!modal) return;

    closeSearch();

    if (state.isOpen) closeDrawer();

    if (state.megamenuOpen) closeMegamenu();

    modal.hidden = false;

    if (overlay) overlay.hidden = false;

    modal.offsetHeight;

    modal.classList.add('is-visible');

    if (overlay) overlay.classList.add('is-visible');

    document.body.classList.add('tt-store-modal-open');

    document.querySelectorAll('[data-tt-location-toggle]').forEach(function(btn) {

      btn.setAttribute('aria-expanded', 'true');

    });

    var closeBtn = modal.querySelector('[data-tt-location-close]');

    if (closeBtn) closeBtn.focus();

    document.addEventListener('keydown', handleLocationModalKeydown);

  }



  function closeLocationPopup() {

    var modal = document.querySelector('[data-tt-location-popup]');

    var overlay = document.querySelector('[data-tt-location-overlay]');

    if (modal) modal.classList.remove('is-visible');

    if (overlay) overlay.classList.remove('is-visible');

    document.body.classList.remove('tt-store-modal-open');

    document.querySelectorAll('[data-tt-location-toggle]').forEach(function(btn) {

      btn.setAttribute('aria-expanded', 'false');

    });

    document.removeEventListener('keydown', handleLocationModalKeydown);

    setTimeout(function() {

      if (modal && !modal.classList.contains('is-visible')) modal.hidden = true;

      if (overlay && !overlay.classList.contains('is-visible')) overlay.hidden = true;

    }, 300);

  }



  function handleLocationModalKeydown(e) {

    if (e.key === 'Escape') closeLocationPopup();

  }



  function showSearchResults() {

    var results = document.querySelector('[data-tt-search-results]');

    if (results) results.hidden = false;

  }



  function performPredictiveSearch(query) {

    if (!query || query.length < 2) {

      hideSearchResults();

      return;

    }

    currentSearchQuery = query;

    var results = document.querySelector('[data-tt-search-results]');

    var loading = document.querySelector('[data-tt-search-loading]');

    var empty = document.querySelector('[data-tt-search-empty]');

    var list = document.querySelector('[data-tt-search-list]');

    var viewAll = document.querySelector('[data-tt-search-view-all]');

    if (!results || !list) return;

    showSearchResults();

    if (loading) loading.hidden = false;

    if (empty) empty.hidden = true;

    if (viewAll) viewAll.hidden = true;

    list.innerHTML = '';



    var apiQuery = query.replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();

    var searchUrl = '/search/suggest.json?q=' + encodeURIComponent(apiQuery) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,variants.barcode';



    fetch(searchUrl)

      .then(function(response) { return response.json(); })

      .then(function(data) {

        if (currentSearchQuery !== query) return;

        if (loading) loading.hidden = true;

        var products = data.resources && data.resources.results && data.resources.results.products;

        if (!products || products.length === 0) {

          if (empty) empty.hidden = false;

          if (viewAll) viewAll.hidden = true;

          return;

        }

        products.forEach(function(product) {

          var li = document.createElement('li');

          li.className = 'tt-search-results__item';

          var imgSrc = product.featured_image && product.featured_image.url

            ? product.featured_image.url

            : (product.image || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png');

          var price = formatPrice(product.price, product.price_min, product.price_max);

          li.innerHTML = '<a href="' + product.url + '" class="tt-search-results__link">' +

            '<img src="' + imgSrc + '" alt="" class="tt-search-results__image" loading="lazy">' +

            '<div class="tt-search-results__info">' +

              '<div class="tt-search-results__title">' + escapeHtml(product.title) + '</div>' +

              (price ? '<div class="tt-search-results__price">' + price + '</div>' : '') +

            '</div>' +

          '</a>';

          list.appendChild(li);

        });

        if (viewAll) {

          viewAll.href = '/search?q=' + encodeURIComponent(query) + '&type=product';

          viewAll.hidden = false;

        }

      })

      .catch(function(error) {

        console.error('Search error:', error);

        if (loading) loading.hidden = true;

        if (empty) {

          empty.textContent = 'Search unavailable';

          empty.hidden = false;

        }

      });

  }



  function formatPrice(price, priceMin, priceMax) {

    if (!price && !priceMin) return '';

    var p = price || priceMin;

    if (typeof p === 'string' && p.indexOf('\u00A3') !== -1) return p;

    var num = typeof p === 'string' ? parseFloat(p) : p;

    if (num > 10000) num = num / 100;

    return '\u00A3' + num.toFixed(2);

  }



  function escapeHtml(text) {

    var div = document.createElement('div');

    div.textContent = text;

    return div.innerHTML;

  }



  function setupPredictiveSearch() {

    var input = document.querySelector(SEL.searchInput);

    if (!input) return;

    input.addEventListener('input', function() {

      var query = input.value.trim();

      clearTimeout(searchDebounceTimer);

      searchDebounceTimer = setTimeout(function() {

        performPredictiveSearch(query);

      }, 300);

    });

    document.addEventListener('click', function(e) {

      var overlay = document.querySelector(SEL.searchOverlay);

      if (overlay && !overlay.contains(e.target) && !e.target.closest(SEL.searchToggle)) {

        hideSearchResults();

      }

    });

  }



  /* ============================================================

     EVENT BINDING

     ============================================================ */

  function bindEvents() {

    // Hamburger toggle — different behavior in sticky vs normal mode

    refs.toggleBtn.forEach(function(btn) {

      btn.addEventListener('click', function() {

        var headerEl = document.querySelector('.tt-header');

        var isSticky = headerEl && headerEl.classList.contains('is-sticky');



        if (isDesktop() && isSticky) {

          // Sticky desktop: toggle L1 strip

          if (state.megamenuOpen) {

            closeMegamenu();

            closeStickyL1Strip();

          } else if (state.stickyL1StripOpen) {

            closeStickyL1Strip();

          } else {

            toggleStickyL1Strip();

          }

        } else {

          // Normal: toggle drawer (mobile + non-sticky desktop)

          if (state.isOpen) closeDrawer();

          else openDrawer();

        }

      });

    });



    // Close button (drawer)

    refs.drawer.querySelectorAll(SEL.closeBtn).forEach(function(btn) {

      btn.addEventListener('click', closeDrawer);

    });



    // Back button (drawer)

    refs.drawer.querySelectorAll(SEL.backBtn).forEach(function(btn) {

      btn.addEventListener('click', navigateBack);

    });



    // Overlay click — closes both drawer and mega menu

    refs.overlay.addEventListener('click', function() {

      if (state.megamenuOpen) closeMegamenu();

      if (state.isOpen) closeDrawer();

    });



    // ---- L1 triggers inside drawer ----

    refs.drawer.querySelectorAll(SEL.l1Trigger).forEach(function(trigger) {

      trigger.addEventListener('click', function(e) {

        e.preventDefault();

        var handle = trigger.dataset.l1Handle;

        var title = trigger.querySelector('.tt-drawer__l1-text').textContent.trim();

        state.navStack = [{ level: 'l1', title: 'Menu' }];

        navigateToL2(handle, title);

      });



      // Desktop hover inside drawer: show L2 alongside L1

      trigger.addEventListener('mouseenter', function(e) {

        if (!state.isDesktop || !state.isOpen || state.isDrilled) return;

        var handle = e.currentTarget.dataset.l1Handle;

        clearTimeout(drawerL1HoverTimer);

        drawerL1HoverTimer = setTimeout(function() {

          showDesktopHoverL2(handle);

          state.navStack = [{ level: 'l1', title: 'Menu' }];

          updateDrawerHeader();

        }, 60);

      });

    });



    // ---- L2 triggers (for L3 drill-down in drawer) ----

    refs.drawer.querySelectorAll(SEL.l2Trigger).forEach(function(trigger) {

      trigger.addEventListener('click', function(e) {

        e.preventDefault();

        var parentHandle = trigger.dataset.l1Handle;

        var handle = trigger.dataset.l2Handle;

        var title = trigger.querySelector('.tt-drawer__l2-text').textContent.trim();

        navigateToL3(parentHandle, handle, title);

      });



      trigger.addEventListener('mouseenter', function() {

        if (!state.isDesktop) return;

        var l1Handle = trigger.dataset.l1Handle;

        var l2Handle = trigger.dataset.l2Handle;

        showDesktopHoverL3(l1Handle, l2Handle);

      });

    });



    // ---- L2 hover links (clickable links that show L3 on hover in drawer) ----

    var l2HoverTimer = null;

    refs.drawer.querySelectorAll(SEL.l2HoverLink).forEach(function(link) {

      link.addEventListener('mouseenter', function() {

        if (!state.isDesktop) return;

        var l1Handle = link.dataset.l1Handle;

        var l2Handle = link.dataset.l2Handle;

        clearTimeout(l2HoverTimer);

        l2HoverTimer = setTimeout(function() {

          showDesktopHoverL3(l1Handle, l2Handle);

        }, 80);

      });



      link.addEventListener('click', function(e) {

        if (state.isDesktop) return;

        e.preventDefault();

        var l1Handle = link.dataset.l1Handle;

        var l2Handle = link.dataset.l2Handle;

        var title = link.querySelector('.tt-drawer__l2-text').textContent.trim();

        navigateToL3(l1Handle, l2Handle, title);

      });

    });



    // Hide L3 when mouse leaves L2 content area (drawer desktop)

    refs.drawer.querySelectorAll('[data-tt-panel="l2"]').forEach(function(l2Panel) {

      var l2Content = l2Panel.querySelector('.tt-drawer__l2-content');

      if (l2Content) {

        l2Content.addEventListener('mouseleave', function(e) {

          if (!state.isDesktop) return;

          var relatedTarget = e.relatedTarget;

          if (relatedTarget && relatedTarget.closest && relatedTarget.closest('[data-tt-panel="l3"]')) return;

          setTimeout(function() {

            var l3Hovered = refs.drawer.querySelector('[data-tt-panel="l3"]:hover');

            if (!l3Hovered) hideDesktopL3();

          }, 100);

        });

      }

    });



    // ---- Header nav links: hover to open MEGA MENU (desktop) ----

    document.querySelectorAll(SEL.headerNavLink).forEach(function(link) {

      link.addEventListener('mouseenter', handleHeaderNavEnter);

      link.addEventListener('mouseleave', handleHeaderNavLeave);
      // 23 Oct 2026 (Town Tools, tablets): on touch screens the first tap on a heading opens its drop-down; a second tap opens the page
      link.addEventListener('click', function(e) {
        if (!window.matchMedia('(hover: none)').matches || !isDesktop()) return;
        var handle = link.dataset.l1Title;
        if (!handle || !document.querySelector('[data-megamenu-panel="' + handle + '"]')) return;
        if (state.megamenuOpen && state.megamenuActiveL1 === handle) return;
        e.preventDefault();
        openMegamenu(handle);
      });


    });



    // ---- Mega menu close button ----

    var megamenuCloseBtn = document.querySelector(SEL.megamenuClose);

    if (megamenuCloseBtn) {

      megamenuCloseBtn.addEventListener('click', closeMegamenu);

    }



    // ---- Mega menu mouse tracking ----

    if (refs.megamenu) {

      refs.megamenu.addEventListener('mouseenter', function() {

        clearTimeout(headerLeaveTimer);

      });



      refs.megamenu.addEventListener('mouseleave', function() {

        headerLeaveTimer = setTimeout(function() {

          var hovered = document.querySelector(SEL.headerNavLink + ':hover');

          var stickyHovered = document.querySelector(SEL.stickyL1Link + ':hover');

          if (!hovered && !stickyHovered && state.megamenuOpen) {

            closeMegamenu();

          }

        }, 300);

      });

    }



    // ---- Sticky L1 strip links ----

    if (refs.stickyL1Links) {

      refs.stickyL1Links.forEach(function(link) {

        link.addEventListener('mouseenter', function() {

          if (!isDesktop()) return;

          var handle = link.dataset.stickyL1;

          clearTimeout(headerLeaveTimer);

          clearTimeout(headerHoverTimer);

          headerHoverTimer = setTimeout(function() {

            if (state.megamenuOpen && state.megamenuActiveL1 === handle) return;

            openMegamenu(handle);

          }, 120);

        });



        link.addEventListener('mouseleave', function() {

          if (!isDesktop()) return;

          clearTimeout(headerHoverTimer);

          headerLeaveTimer = setTimeout(function() {

            if (refs.megamenu && refs.megamenu.matches(':hover')) return;

            if (state.megamenuOpen) closeMegamenu();

          }, 250);

        });



        link.addEventListener('click', function(e) {

          if (!isDesktop()) return;

          var handle = link.dataset.stickyL1;

          var panel = document.querySelector('[data-megamenu-panel="' + handle + '"]');

          if (panel) {

            e.preventDefault();

            openMegamenu(handle);

          }

        });

      });

    }



    // Keep drawer open when mouse enters it (from header hover — still used for non-mega flows)

    refs.drawer.addEventListener('mouseenter', function() {

      clearTimeout(headerLeaveTimer);

    });



    refs.drawer.addEventListener('mouseleave', function() {

      if (!state.isDesktop || state.isDrilled) return;

      headerLeaveTimer = setTimeout(function() {

        var hovered = document.querySelector(SEL.headerNavLink + ':hover');

        if (!hovered && state.isOpen && !state.isDrilled) {

          closeDrawer();

        }

      }, 300);

    });



    // Search toggle

    document.querySelectorAll(SEL.searchToggle).forEach(function(btn) {

      btn.addEventListener('click', toggleSearch);

    });

    document.querySelectorAll(SEL.searchClose).forEach(function(btn) {

      btn.addEventListener('click', closeSearch);

    });



    // Store locator modal

    document.querySelectorAll('[data-tt-location-toggle]').forEach(function(btn) {

      btn.addEventListener('click', toggleLocationPopup);

    });

    document.querySelectorAll('[data-tt-location-close]').forEach(function(btn) {

      btn.addEventListener('click', closeLocationPopup);

    });

    var locationOverlay = document.querySelector('[data-tt-location-overlay]');

    if (locationOverlay) {

      locationOverlay.addEventListener('click', closeLocationPopup);

    }



    // Resize handler

    var resizeTimer;

    window.addEventListener('resize', function() {

      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(function() {

        var wasDesktop = state.isDesktop;

        state.isDesktop = isDesktop();



        // Close desktop-only features if we went below 768px

        if (wasDesktop && !state.isDesktop) {

          if (state.megamenuOpen) closeMegamenu();

          if (state.stickyL1StripOpen) closeStickyL1Strip();

        }



        if (state.isOpen) updateDrawerPosition();

        if (state.megamenuOpen) updateMegamenuPosition();

      }, 150);

    });

  }



  var drawerL1HoverTimer = null;



  /* ============================================================

     INIT

     ============================================================ */

  function init() {

    refs.drawer = document.querySelector(SEL.drawer);

    refs.overlay = document.querySelector(SEL.overlay);

    refs.toggleBtn = document.querySelectorAll(SEL.toggleBtn);

    refs.megamenu = document.querySelector(SEL.megamenu);

    refs.megamenuPanels = document.querySelectorAll(SEL.megamenuPanel);

    refs.stickyL1Strip = document.querySelector(SEL.stickyL1Strip);

    refs.stickyL1Links = document.querySelectorAll(SEL.stickyL1Link);



    if (!refs.drawer || !refs.overlay) return;



    state.isDesktop = isDesktop();



    bindEvents();



    var headerWrapper = document.querySelector('.site-header-wrapper');

    if (headerWrapper) {

      headerWrapper.classList.add('tt-header-active');

    }



    setupStickyHeader();

    setupPredictiveSearch();

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }



})();





/* Town Tools: make the desktop nav's horizontal overflow discoverable */
(function(){
  function init(){
    var nav=document.querySelector('.tt-header__nav'), sc=document.querySelector('.tt-header__nav-scroll');
    if(!nav||!sc||nav.querySelector('.tt-nav-arrow')) return;
    var btn=document.createElement('button');
    btn.className='tt-nav-arrow'; btn.type='button'; btn.setAttribute('aria-label','Scroll navigation right');
    btn.innerHTML='<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M7 4l6 6-6 6"/></svg>';
    btn.addEventListener('click', function(){ sc.scrollBy({left: Math.round(sc.clientWidth*0.7), behavior:'smooth'}); });
    nav.appendChild(btn);
    function upd(){
      var over = sc.scrollWidth - sc.clientWidth > 4;
      nav.classList.toggle('has-overflow', over);
      nav.classList.toggle('at-end', over && (sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 4));
    }
    sc.addEventListener('scroll', upd, {passive:true});
    window.addEventListener('resize', upd);
    upd(); setTimeout(upd, 600);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();


/* Desktop: flag nav items that open a mega-menu panel so CSS can add a chevron */
(function(){
  function mark(){
    var links=document.querySelectorAll('.tt-header__nav-link');
    for(var i=0;i<links.length;i++){
      var k=links[i].getAttribute('data-l1-title');
      if(k && document.querySelector('[data-megamenu-panel="'+k+'"]')) links[i].classList.add('has-panel');
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', mark); else mark();
  setTimeout(mark, 800);
})();
